const jsonp = require('jsonp')

module.exports = function reports (n, s, base) {
  base = (base || 'http://localhost:9053/').replace(/\/?$/, '/')

  const waiting = []
  let isComputing = undefined
  let hash = undefined
  function getHash (callback) {
    if (hash) return callback(hash)
    waiting.push(callback)
    if (isComputing === true) return
    isComputing = true

    const fingerprint = require('fingerprintjs2/dist/fingerprint2.min.js')

    // The swisscom tv box provides a user-agent with the MAC address in it:
    // User-Agent: Dalvik/1.6.0 (Linux; U; Android 4.2.2; swisscom_residental Build/JDQ39; mac:e4:3e:d7:b9:22:44)
    const tvBoxUa = navigator.userAgent && navigator.userAgent.match(/; mac:([a-h0-9:]+)/) && RegExp.$1
    if (tvBoxUa) {
      hash = `mac:${tvBoxUa}`
      for (const cb of waiting) cb(hash)
      return
    }

    const idle = window.requestIdleCallback ? (fn) => window.requestIdleCallback(fn) : (fn) => window.setTimeout(fn, 10)
    idle(() => {
      fingerprint.get((cs) => {
        const values = cs.map((c) => JSON.stringify(c.value)).join('')
        hash = fingerprint.x64hash128(values, 31)
        for (const cb of waiting) cb(hash)
      })
    })
  }

  return {
    track (event, questionId, answerId, callback) {
      getHash((hash) => {
        jsonp(`${base}r?n=${n}&s=${s}&e=${event}${questionId ? `&q=${questionId}`: ''}${answerId ? `&a=${answerId}`: ''}&c=${hash}`, callback)
      })
    },
    stats (cb) {
      getHash((hash) => {
        jsonp(`${base}stats?n=${n}&s=${s}&c=${hash}`, cb)
      })
    },
    start (cb) {
      this.track('start', null, null, cb)
    },
    vote (questionId, answerId, cb) {
      this.track('vote', questionId, answerId, cb)
    },
    finish (cb) {
      this.track('finish', null, null, cb)
    }
  }
}
